import { render, staticRenderFns } from "./SmplEditAbout.vue?vue&type=template&id=09a3b2ac&scoped=true&"
import script from "./SmplEditAbout.vue?vue&type=script&lang=js&"
export * from "./SmplEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a3b2ac",
  null
  
)

export default component.exports